module.exports = __webpack_public_path__ + "feature-highlight-1-2x-1df5f768a428896672aed8a1e6dbe44a.webp";